import { render, staticRenderFns } from "./Loyalty.template.vue?vue&type=template&id=2dc78daf&scoped=true&"
var script = {}
import style0 from "./Loyalty.template.vue?vue&type=style&index=0&id=2dc78daf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc78daf",
  null
  
)

export default component.exports